import { useLeaderboard } from "#/shared/hooks"

import LeaderboardMatsStats from "./LeaderboardMatsStats"
import LeaderboardTable from "./LeaderboardTable"

export default function LeaderboardTab() {
  const { leaderboard, isLeaderboardFullyFetched, loadMore, currentUserRank } =
    useLeaderboard()

  return (
    <>
      <LeaderboardMatsStats />
      <LeaderboardTable
        leaderboard={leaderboard}
        isLeaderboardFullyFetched={isLeaderboardFullyFetched}
        loadMore={loadMore}
        currentUserRank={currentUserRank}
        isMatsLeaderboard
      />
    </>
  )
}
